export const RiskLevels = ['LOW', 'MEDIUM', 'HIGH'];

export const MaxPrices = [100, 200, 300, 500, 1000];

export const WIZARD_STEP_HORSES = 'horses';
export const WIZARD_STEP_SYSTEM_TYPE = 'systemType';
export const WIZARD_STEP_CREATE_SYSTEM = 'createSystem';
export const WizardSteps = [
  WIZARD_STEP_HORSES,
  WIZARD_STEP_SYSTEM_TYPE,
  WIZARD_STEP_CREATE_SYSTEM,
];

export const Layouts = ['ATTACK', 'STANDARD', 'TV'];

export const MaxPriceTypes = {
  button: 'button',
  field: 'field',
};
